module.exports = require("fs");


//////////////////
// WEBPACK FOOTER
// external "fs"
// module id = 3
// module chunks = 0